import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { CategoryOverviewComponent } from './category-overview/category-overview.component';
import { AuthInfoService } from '../../core/auth-info/auth-info.service';
import { resolveAuthInfo } from '../../core/auth-info/auth-info.resolver';

export const CATEGORY_STATES: Ng2StateDeclaration[] = [
  {
    name: 'app.settings.category',
    redirectTo: 'app.settings.category.overview',
    url: '/category',
    params: {
      security: {
        enabled: true,
        roles: [],
      },
      style: {
        feedback: true,
        hasMainMenu: true,
        hasSubMenu: true,
        hasSideNav: false,
      },
    },
    resolve: [
      {
        token: 'authInfo',
        deps: [AuthInfoService],
        resolveFn: resolveAuthInfo,
      },
    ],
  },
  {
    name: 'app.settings.category.overview',
    views: {
      '$default@app': {
        component: CategoryOverviewComponent,
      },
    },
    url: '/',
  },
];
